// import adminWhite from "../../assets/img/svg/admin-white.svg";
// import adminOrange from "../../assets/img/svg/admin-orange.svg";
import phoneWhite from "../../assets/img/svg/phone-white.svg";
import phoneBlue from "../../assets/img/svg/phone-blue.svg";
// import tabletOrange from "../../assets/img/svg/tablet-orange.svg";
// import tabletWhite from "../../assets/img/svg/tablet-white.svg";
import desktopGreen from "../../assets/img/svg/desktop-green.svg";
import desktopWhite from "../../assets/img/svg/desktop-white.svg";
import creditCardPayType from '../../assets/img/svg/credit-card-pay-type.svg'
import unionPayType from '../../assets/img/svg/union-pay-type.svg'
import bankInPayType from '../../assets/img/svg/bank-in-payment-type.svg'
import cashPayType from '../../assets/img/svg/cash-pay-type.svg'
import chequePayType from '../../assets/img/svg/cheque-payment-type.svg'

const DRIVING_SKILL_ID = 13;
const DRIVER_ROLE_ID = 2;
const BABY_CARE_SKILL_ID = 1;
const ELDERLY_CARE_SKILL_ID = 5;

const PARTNER_BANGLADESH_COUNTRY_ID = 14;
const PARTNER_THAILAND_COUNTRY_ID = 170;
const PARTNER_PHILIPPINES_COUNTRY_ID = 141;
const PARTNER_INDONESIAN_COUNTRY_ID = 77;

export const indonesiaId = 95;
export const fillipinoId = 71;
export const bangladeshId = 18;
export const thaiId = 198;

let workerFilters = {
  limit: 10,
  page: 1,
  sort_by: "created_at",
  sort_order: "DESC",
};

let workerFiltersInsurance = {
  limit: 10,
  page: 1,
  sort_by: "created_at",
  sort_order: "DESC",
  profile_status: "dashboard_1",
};

let invoiceFilters = {
  limit: 10,
  page: 1,
  sort_by: "created_at",
  sort_order: "DESC",
};

let insuranceFilters = {
  limit: 10,
  page: 1,
  sort_by: "effective_date",
  sort_order: "DESC"
};

const jobOfferFilters = {
  search_text: "",
  office_location: "",
  status: [],
  device_type: "",
  branch_location: [],
  start_date: "",
  end_date: "",
};
let contractsFilters = {
  limit: 10,
  page: 1,
  sort_by: "",
  sort_order: ""
};
const fillterListOne = [
  { name: "All", id: 0 },
  { name: "Admin", id: 1 },
  { name: "Direct", id: 2 },
];

const chatTypes = [
  { name: "Employer Chats", id: 0 },
  { name: "Worker Chats", id: 1 },
];

//permissions
const allPermissions = {
  employer: "employer",
  empRegisterLink: "employer.send_registration_link",
  addEmployer: "employer.add",
  editEmployer: "employer.update",
  empChangeStatus: "employer.change_status",
  empInfo: "employer.info",
  empJobOffer: "employer.info.job_offer",
  empActivity: "employer.info.activity",
  empContract: "employer.info.contract",
  empInvoice: "employer.info.invoice",
  empDetails: "employer.info.details",
  empChat: "employer.info.chat",
  worker: "worker",
  workerRegisterLink: "worker.send_registration_link",
  addWorker: "worker.add",
  editWorker: "worker.update",
  workerChangeStatus: "worker.change_status",
  workerInfo: "worker.info",
  workerJobOffer: "worker.info.job_offer",
  workerActivity: "worker.info.activity",
  workerContract: "worker.info.contract",
  workerInvoice: "worker.info.invoice",
  workerDetails: "worker.info.details",
  workerChat: "worker.info.chat",
  jobOffer: "job offer",
  addJobOffer: "job_offer.add",
  editJobOffer: "job_offer.update",
  jobOfferChangeStatus: "job_offer.change_status",
  jobOfferInfo: "job_offer.info",
  jobOfferDetails: "job_offer.info.details",
  jobOfferInviteWorkerList: "job_offer.info.invite_worker_list",
  jobOfferInviteWorker: "job_offer.invite_worker",
};


const discount = (amount, perct) => {
  let dis = (perct / 100) * amount;
  return amount - dis;
};


const filterDevices = [
  { type: 'Direct', filterType: 2, blueImage: phoneWhite, grayImage: phoneBlue },
  { type: 'Web', filterType: 1, blueImage: desktopWhite, grayImage: desktopGreen },
  // { type: 'Tablet', filterType: 3, blueImage: tabletWhite, grayImage: tabletOrange },
  // { type: 'Admin', filterType: 4, blueImage: adminWhite, grayImage: adminOrange },
];
const status = [
  { id: 0, name: 'key_inactive' },
  { id: 1, name: 'key_active' },
  { id: 2, name: 'key_all' },
];
export const assignmentTypes = ['manual', 'round_robin', 'both'];
export const contract_types = ['new', 'renew', 'both'];

export const dateRangeFilterOptions = () => {
  return [
    { id: 7, name: 'Last 7 days' },
    { id: 30, name: 'Last 30 days' },
    { id: 60, name: 'Last 60 days' },
    { id: 90, name: 'Last 90 days' },
    { id: 365, name: 'Last 1 year' },
  ]
};

export const workerTypeList = () => {
  return [
    { id: 1, name: "Local", key: 'local', translationKey: 'key_local' },
    { id: 2, name: "Overseas", key: 'overseas', translationKey: 'key_overseas' },
  ]
};

export const workerTypeListLocal = () => {
  return [
    { id: 1, name: "Local", key: 'local' },
  ]
};

export const typeInternal = () => {
  return [
    { name: "New", key: 'new' },
    { name: "Replacement", key: 'replacement' },
  ]
};

export const workerNationalityList = () => {
  return [
    { id: 95, name: "Indonesia", key: "indonesia" },
    { id: 71, name: "Philippines", key: "philippines" },
    { id: 18, name: "Bangladeshi", key: "bangladeshi" },
    { id: 198, name: "Thai", key: "thai" },
  ]
};

export const salaryBasis = [
  { id: 'daily', name: "Daily" },
  { id: 'weekly', name: "Weekly" },
  { id: 'semi_monthly', name: "Semi Monthly" },
  { id: 'monthly', name: "Monthly" },
  { id: 'annual', name: "Annual" },
];

export const WorkerBioDataStatus = () => {
  return [
    { id: 'in_complete', name: "In Completed" },
    { id: 'in_review', name: "In Review" },
    { id: 'uploaded', name: "Uploaded" },
    { id: 'verified', name: "Verified" },
    { id: 'action_required', name: "Action Required" },
  ]
};

export const exceptionsStatusList = () => {
  return [
    { id: 0, name: "No" },
    { id: 1, name: "Yes" },
    { id: 2, name: "Consider" },
  ]
};

export const interviewDayList = () => {
  return [
    { id: 1, name: "Any Day" },
    { id: 2, name: "Sunday" },
    { id: 3, name: "Saturday" },
    { id: 4, name: "Friday" },
    { id: 5, name: "Thursday" },
    { id: 6, name: "Wednesday" },
    { id: 7, name: "Tuesday" },
    { id: 8, name: "Monday" },
  ]
};
export const timeSlots = [
  "8 AM", "8:30 AM", "9 AM", "9:30 AM", "10 AM", "10:30 AM", "11 AM", "11:30 AM",
  "12 PM", "12:30 PM", "1 PM", "1:30 PM", "2 PM", "2:30 PM", "3 PM", "3:30 PM",
  "4 PM", "4:30 PM", "5 PM", "5:30 PM", "6 PM", "6:30 PM"
];

export const getInsuranceSubmissionEmpDetails = () => [
  { title: 'Surname', value: 'Lee' },
  { title: 'Given Name', value: 'Chang Yeun Yi' },
  { title: 'Phone', value: '852812791' },
  { title: 'Email ID', value: 'chang@gmail.com' },
  { title: 'Date of Birth', value: '11/02/1993' },
  { title: 'Age', value: '33' },
  { title: 'HKID', value: '1234455' },
  { title: 'Address', value: '12, Alberto Heights, East Parkwood, Hong Kong, 400614' },
];

export const getInsuranceSubmissionWorkerDetails = () => [
  { title: 'Surname', value: 'De La Sanchez' },
  { title: 'Given Name', value: 'Angelissa' },
  { title: 'Worker Code', value: 'LPF129390' },
  { title: 'Phone', value: '852812791' },
  { title: 'Nationality', value: 'Indonesian' },
  { title: 'Date of Birth', value: '11/02/1993' },
  { title: 'Age', value: '33' },
  { title: 'Passport No', value: 'L-1234' },
  { title: 'HKID', value: '1234455' },

];

export const getInsuranceSubmissionInsuranceDetails = () => [
  { title: 'Insurance Type', value: 'Renew' },
  { title: 'Policy', value: 'One Year Full insurance with Cancer and Heart Disease' },
  { title: 'Previous Policy No', value: '38998292834' },
  { title: 'Policy Number', value: '' },
  { title: 'Effective Date', value: '' },
  { title: 'Expiry Date', value: '' },
  { title: 'Invoice', value: 'I-N37192928' },
];

export const configModules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image', 'video'],
    ['clean'],
  ],
};
const invoiePaymentTypes = [
  {
    value: "credit_card",
    label: "Credit Card",
    translationKey: 'key_credit_card',
    img: creditCardPayType,
    popupTitle: 'Enter Transaction Time Code',
    paymentTypeMessage: 'Please swipe the card on the terminal. Once done, enter the time code shown from the machine in the field below:'
  },
  {
    value: "union_pay",
    label: "Union Pay",
    translationKey: 'key_union_pay',
    img: unionPayType,
    popupTitle: 'Enter Transaction Time Code',
    paymentTypeMessage: `
    Please swipe the card on the terminal. Once done, enter the time code shown from the machine in the field below:
    `
  },
  {
    value: "bank_in",
    label: "Bank In",
    translationKey: 'key_bank_in',
    img: bankInPayType,
    popupTitle: 'Confirm Bank In Payment Details',
    paymentTypeMessage: `
    Please upload a scanned image of the <b>Bank In reference</b> to the Invoice within 48 hours to complete verification.
    <br><br>
    If the scan is not uploaded within 48 hours, Invoice status will automatically change to <b>Unsettled</b>.
  `
  },
  {
    value: "cash",
    label: "Cash",
    translationKey: 'key_cash',
    img: cashPayType,
    popupTitle: 'Confirm Cash Payment Details',
    paymentTypeMessage: `
    Please upload a scanned image of the <b>deposit receipt</b> to the Invoice within 48 hours to complete verification.
    <br><br>
    If the scan is not uploaded within 48 hours, Invoice status will automatically change to<b> Unsettled</b>.
    `
  },
  {
    value: "cheque",
    label: "Cheque",
    translationKey: 'key_cheque',
    img: chequePayType,
    popupTitle: 'Confirm Cheque Details',
    paymentTypeMessage: `Please upload a scanned image of the <b>cheque</b> to the Invoice within 48 hours to complete verification.
    <br><br>
    If the scan is not uploaded within 48 hours, Invoice status will automatically change to <b>Unsettled</b>.`
  },
];

const invoiePaymentTypesTrans = ({ t }) => {
  return [
    {
      value: "credit_card",
      label: t('key_credit_card'),
      img: creditCardPayType,
      popupTitle: t('key_enter_transaction_time_code'),
      paymentTypeMessage: t('key_credit_card_message')
    },
    {
      value: "union_pay",
      label: t('key_union_pay'),
      img: unionPayType,
      popupTitle: t('key_enter_transaction_time_code'),
      paymentTypeMessage: t('key_union_pay_message')
    },
    {
      value: "bank_in",
      label: t('key_bank_in'),
      img: bankInPayType,
      popupTitle: t('key_confirm_bank_in_payment_details'),
      paymentTypeMessage: t('key_bank_in_message')
    },
    {
      value: "cash",
      label: t('key_cash'),
      img: cashPayType,
      popupTitle: t('key_confirm_cash_payment_details'),
      paymentTypeMessage: t('key_cash_message')
    },
    {
      value: "cheque",
      label: t('key_cheque'),
      img: chequePayType,
      popupTitle: t('key_confirm_cheque_details'),
      paymentTypeMessage: t('key_cheque_message')
    },
  ];
};

const invoieRefundPaymentTypes = [
  {
    value: "credit_card",
    label: "Credit Card",
    img: creditCardPayType,
    popupTitle: 'Enter Transaction Time Code',
    paymentTypeMessage: 'Please swipe the card on the terminal. Once done, enter the time code shown from the machine in the field below:'
  },
  {
    value: "cheque",
    label: "Cheque",
    img: chequePayType,
    popupTitle: 'Confirm Cheque Details',
    paymentTypeMessage: `Please upload a scanned image of the <b>cheque</b> to the Invoice within 48 hours to complete verification.
    <br><br>
    If the scan is not uploaded within 48 hours, Invoice status will automatically change to <b>Unsettled</b>.`
  },
];

const refundInvoiePaymentTypes = [
  {
    value: "credit_card",
    label: "Credit Card",
    img: creditCardPayType,
    popupTitle: 'Enter Transaction Time Code',
    paymentTypeMessage: 'Please swipe the card on the terminal. Once done, enter the time code shown from the machine in the field below:'
  },
  {
    value: "cheque",
    label: "Cheque",
    img: chequePayType,
    popupTitle: 'Confirm Cheque Details',
    paymentTypeMessage: `Please upload a scanned image of the <b>cheque</b> to the Invoice within 48 hours to complete verification.
    <br><br>
    If the scan is not uploaded within 48 hours, Invoice status will automatically change to <b>Unsettled</b>.`
  },
];

const jobGlobalFilters = {
  branch_location: [],
  location: '',
  status: [],
  device_type: '',
  search_text: '',
  from_date: '',
  to_date: '',
  dateRangeId: '',
  sort_by: '',
  sort_order: '',
  page: 1,
  limit: 10,
};

const processingGlobalFilters = {
  group: '',
  sort_by: '',
  sort_order: '',
  page: 1,
  limit: 10,
};
const partnerbGlobalFilters = {
  search_text: '',
  status: [],
  sort_by: '',
  sort_order: '',
  page: 1,
  limit: 10,
};

let workerGlobalFilters = {
  "page": 1,
  "search_text": "",
  "sort_by": "",
  "sort_order": "",
  "limit": 10,
  "type": "",
  "status": [],
  "profile_status": "",
  "nationality": [],
  "reference_id": [],
};

const qrOptions = (translation) => {
  return [
    {
      id: 1,
      name: translation('key_open_check_in_qr_code'),
      type: 0,
    },
    {
      id: 2,
      name: translation('key_open_check_in_qr_code'),
      type: 0,
    },
    {
      id: 3,
      name: translation('key_open_check_in_qr_code'),
      type: 0,
    }
  ]
}

let workerJobOfferFilters = {
  "page": 1,
  "search_text": "",
  "sort_by": "",
  "sort_order": "",
  "limit": 10,
};
const categories = [
  { key: 'adult', label: 'Adults', translationKey: 'key_adults' },
  { key: 'expecting_baby', label: 'Expecting Baby', translationKey: 'key_expecting_baby' },
  { key: 'baby', label: 'Baby', translationKey: 'key_baby' },
  { key: 'child', label: 'Child', translationKey: 'key_child' },
  { key: 'elderly', label: 'Elderly', translationKey: 'key_elderly' }
];

const feedbackReportFilters = {
  feedback_type: [],
  created_by_type: [],
  rating: [],
  start_date: null,
  end_date: null,
  selected_date_range_type: 'auto'
};

const templateFiltersData = {
  module_key: "",
  category_id: "",
  language_id: "",
  template_type: "",
  search_text: '',
  accessibility: "",
  page: 1,
  limit: 10,
};

const feedbackTypeOptions = [
  { value: 'helper', label: 'Helper' },
  { value: 'employer', label: 'Employer' },
  { value: 'customer_service', label: 'Customer Service' },
  { value: 'report_a_bug', label: 'Bug Report' },
  { value: 'other', label: 'Other' }
];

const userTypeOptions = [
  { value: 'employer', label: 'Employer' },
  { value: 'worker', label: 'Worker' }
];

const ratingOptions = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' }
];

const accessPermissionOptions = [
  { id: "restricted", name: 'key_restricted' },
  { id: "full_access", name: 'key_full_access' }
];

const accessList = [
  { id: "public", name: 'Public', translationKey: 'key_public' },
  { id: "private", name: 'Private', translationKey: 'key_private' }
];

const getDateRangeMap = (translation) => {
  return {
    "yesterday": translation('key_yesterday'),
    "last_7_days": translation('key_last_7_days'),
    "last_30_days": translation('key_last_30_days'),
    "last_60_days": translation('key_last_60_days'),
    "last_90_days": translation('key_last_90_days'),
    "this_month": translation('key_this_month'),
    "last_month": translation('key_last_month'),
    "this_quarter": translation('key_this_quarter'),
    "year_to_date": translation('key_year_to_date'),
    "last_year": translation('key_last_year')
  };
}

const dateRangeStaticProps = [
  "yesterday",
  "last_7_days",
  "last_30_days",
  "last_60_days",
  "last_90_days",
  "this_month",
  "last_month",
  "this_quarter",
  "year_to_date",
  "last_year",
  "y",
  "n",
]

const calendarEvents = [
  {
    title: 'key_upcoming_interview',
    class: 'upcoming'
  },
  {
    title: 'key_cancelled_interview',
    class: 'cancelled'
  },
  {
    title: 'key_completed_interview',
    class: 'completed'
  },
  {
    title: 'key_processing_follow_up',
    class: 'follow-up'
  },
  {
    title: 'key_payment_follow_up',
    class: 'follow-up'
  },
  {
    title: 'key_task',
    class: 'task'
  }
];

const columnOrdersByGroup = (t) => {
  const base = [t('key_name'), t('key_delay'), t('key_contract')];

  return {
    1: [
      ...base,
      t('key_consulate'),
      t('key_immigration'),
      t('key_visa'),
      t('key_insurance'),
      t('key_deployment'),
    ],
    2: [
      ...base,
      t('key_pre_departure'),
      t('key_immigration'),
      t('key_visa'),
      t('key_insurance'),
      t('key_consulate'),
      t('key_deployment'),
    ],
    3: [
      ...base,
      t('key_insurance'),
      t('key_medical'),
      t('key_consulate'),
      t('key_immigration'),
      t('key_visa'),
    ],
    4: [
      ...base,
      t('key_insurance'),
      t('key_medical'),
      t('key_immigration'),
      t('key_visa'),
      t('key_consulate'),
    ],
  };
};

const processingTabRequiredStatuses = {
  contract: 'ready',
  consulate: 'returned',
  // deployment: 'ready', 
  medical: 'approved_by_er',
  insurance: 'ready',
  immigration: 'submitted',
  visa: 'visa_released',
};

const interviewReportFilters = {
  page: 1,
  limit: 10,
  search_text: '',
  branch_id: [],
  cs_id: [],
  interpreter_id: [],
  interview_category: [],
  from_date: '',
  to_date: '',
  selected_date_range_type: 'auto',
};

const jobOfferReportFilters = {
  page: 1,
  limit: 10,
  search_text: '',
  branch_id: [],
  created_by: [],
  cs_owner_id: [],
  search_from_date: '',
  search_to_date: '',
};

const contractReportFilters = {
  page: 1,
  limit: 10,
  contract_from_date: '',
  contract_to_date: '',
  visa_expiry_from_date: '',
  visa_expiry_to_date: '',
  status: [],
  contract_type: [],
  nationality: [],
  contract_status: [],
  worker_reference_id: [],
  worker_current_location: [],
  branch_id: [],
  staff_id: [],
};

const insuranceReportFilters = {
  page: 1,
  limit: 10,
  expiry_from_date: '',
  expiry_to_date: '',
  effective_from_date: '',
  effective_to_date: '',
  branch_id: [],
  staff_id: [],
  type: [],
};

const getInterviewCategoryOptions = (category) => {
  switch (category) {
    case 'qr':
      return 'key_qr';
    case 'instant':
      return 'key_instant';
    case 'admin_scheduled':
      return 'key_admin_scheduled';
    case 'employer_scheduled':
      return 'key_employer_scheduled';
    case 'worker_requested':
      return 'key_worker_requested';
    default:
      return null;
  }
}

const getAccessOptions = () => {
  return [
    { id: "restricted", name: "Restricted" },
    { id: "full_access", name: "Full Access" }
  ];
};

let constData = {
  PARTNER_BANGLADESH_COUNTRY_ID,
  PARTNER_THAILAND_COUNTRY_ID,
  PARTNER_PHILIPPINES_COUNTRY_ID,
  PARTNER_INDONESIAN_COUNTRY_ID,
  filterDevices,
  workerTypeList,
  workerNationalityList,
  workerFilters,
  jobOfferFilters,
  fillterListOne,
  chatTypes,
  allPermissions,
  invoiePaymentTypesTrans,
  discount,
  status,
  assignmentTypes,
  contract_types,
  salaryBasis,
  WorkerBioDataStatus,
  invoiePaymentTypes,
  refundInvoiePaymentTypes,
  jobGlobalFilters,
  partnerbGlobalFilters,
  workerGlobalFilters,
  invoieRefundPaymentTypes,
  contractsFilters,
  insuranceFilters,
  workerJobOfferFilters,
  categories,
  invoiceFilters,
  processingGlobalFilters,
  workerFiltersInsurance,
  DRIVING_SKILL_ID,
  DRIVER_ROLE_ID,
  BABY_CARE_SKILL_ID,
  ELDERLY_CARE_SKILL_ID,
  ratingOptions,
  userTypeOptions,
  feedbackTypeOptions,
  feedbackReportFilters,
  accessPermissionOptions,
  templateFiltersData,
  accessList,
  getDateRangeMap,
  calendarEvents,
  columnOrdersByGroup,
  processingTabRequiredStatuses,
  interviewReportFilters,
  jobOfferReportFilters,
  contractReportFilters,
  insuranceReportFilters,
  getInterviewCategoryOptions,
  getAccessOptions,
  dateRangeStaticProps,
  qrOptions
};

export default constData;
